var _toConsumableArray = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _slicedToArray = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? t(exports) : "function" == typeof define && define.amd ? define(["exports"], t) : t((e = e || self).AceSdk = {});
}(this, function (e) {
  "use strict";

  var _t = function t(e, n) {
    return (_t = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var n in t) {
        t.hasOwnProperty(n) && (e[n] = t[n]);
      }
    })(e, n);
  };

  function n(e, t, n, r) {
    return new (n || (n = Promise))(function (o, i) {
      function s(e) {
        try {
          a(r.next(e));
        } catch (e) {
          i(e);
        }
      }

      function c(e) {
        try {
          a(r.throw(e));
        } catch (e) {
          i(e);
        }
      }

      function a(e) {
        e.done ? o(e.value) : new n(function (t) {
          t(e.value);
        }).then(s, c);
      }

      a((r = r.apply(e, t || [])).next());
    });
  }

  function r(e, t) {
    var n,
        r,
        o,
        i,
        s = {
      label: 0,
      sent: function sent() {
        if (1 & o[0]) throw o[1];
        return o[1];
      },
      trys: [],
      ops: []
    };
    return i = {
      next: c(0),
      throw: c(1),
      return: c(2)
    }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
      return this;
    }), i;

    function c(i) {
      return function (c) {
        return function (i) {
          if (n) throw new TypeError("Generator is already executing.");

          for (; s;) {
            try {
              if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;

              switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                case 0:
                case 1:
                  o = i;
                  break;

                case 4:
                  return s.label++, {
                    value: i[1],
                    done: !1
                  };

                case 5:
                  s.label++, r = i[1], i = [0];
                  continue;

                case 7:
                  i = s.ops.pop(), s.trys.pop();
                  continue;

                default:
                  if (!(o = (o = s.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                    s = 0;
                    continue;
                  }

                  if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                    s.label = i[1];
                    break;
                  }

                  if (6 === i[0] && s.label < o[1]) {
                    s.label = o[1], o = i;
                    break;
                  }

                  if (o && s.label < o[2]) {
                    s.label = o[2], s.ops.push(i);
                    break;
                  }

                  o[2] && s.ops.pop(), s.trys.pop();
                  continue;
              }

              i = t.call(e, s);
            } catch (e) {
              i = [6, e], r = 0;
            } finally {
              n = o = 0;
            }
          }

          if (5 & i[0]) throw i[1];
          return {
            value: i[0] ? i[1] : void 0,
            done: !0
          };
        }([i, c]);
      };
    }
  }

  var o = function o(e) {
    return encodeURIComponent(e).replace(/[!'()*]/g, function (e) {
      return "%".concat(e.charCodeAt(0).toString(16).toUpperCase());
    });
  },
      i = new RegExp("%[a-f0-9]{2}", "gi"),
      s = new RegExp("(%[a-f0-9]{2})+", "gi");

  function c(e, t) {
    try {
      return decodeURIComponent(e.join(""));
    } catch (e) {}

    if (1 === e.length) return e;
    t = t || 1;
    var n = e.slice(0, t),
        r = e.slice(t);
    return Array.prototype.concat.call([], c(n), c(r));
  }

  function a(e) {
    try {
      return decodeURIComponent(e);
    } catch (r) {
      for (var t = e.match(i), n = 1; n < t.length; n++) {
        t = (e = c(t, n).join("")).match(i);
      }

      return e;
    }
  }

  var u = function u(e) {
    if ("string" != typeof e) throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + typeof e + "`");

    try {
      return e = e.replace(/\+/g, " "), decodeURIComponent(e);
    } catch (t) {
      return function (e) {
        for (var t = {
          "%FE%FF": "��",
          "%FF%FE": "��"
        }, n = s.exec(e); n;) {
          try {
            t[n[0]] = decodeURIComponent(n[0]);
          } catch (e) {
            var r = a(n[0]);
            r !== n[0] && (t[n[0]] = r);
          }

          n = s.exec(e);
        }

        t["%C2"] = "�";

        for (var o = Object.keys(t), i = 0; i < o.length; i++) {
          var c = o[i];
          e = e.replace(new RegExp(c, "g"), t[c]);
        }

        return e;
      }(e);
    }
  },
      l = function l(e, t) {
    if ("string" != typeof e || "string" != typeof t) throw new TypeError("Expected the arguments to be of type `string`");
    if ("" === t) return [e];
    var n = e.indexOf(t);
    return -1 === n ? [e] : [e.slice(0, n), e.slice(n + t.length)];
  };

  function f(e, t) {
    return t.encode ? t.strict ? o(e) : encodeURIComponent(e) : e;
  }

  function h(e, t) {
    return t.decode ? u(e) : e;
  }

  var d,
      g = function g(e, t) {
    var n = function (e) {
      var t;

      switch (e.arrayFormat) {
        case "index":
          return function (e, n, r) {
            t = /\[(\d*)\]$/.exec(e), e = e.replace(/\[\d*\]$/, ""), t ? (void 0 === r[e] && (r[e] = {}), r[e][t[1]] = n) : r[e] = n;
          };

        case "bracket":
          return function (e, n, r) {
            t = /(\[\])$/.exec(e), e = e.replace(/\[\]$/, ""), t ? void 0 !== r[e] ? r[e] = [].concat(r[e], n) : r[e] = [n] : r[e] = n;
          };

        case "comma":
          return function (e, t, n) {
            var r = "string" == typeof t && t.split("").indexOf(",") > -1 ? t.split(",") : t;
            n[e] = r;
          };

        default:
          return function (e, t, n) {
            void 0 !== n[e] ? n[e] = [].concat(n[e], t) : n[e] = t;
          };
      }
    }(t = Object.assign({
      decode: !0,
      arrayFormat: "none"
    }, t)),
        r = Object.create(null);

    if ("string" != typeof e) return r;
    if (!(e = e.trim().replace(/^[?#&]/, ""))) return r;
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = e.split("&")[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var _o = _step.value;

        var _l = l(_o.replace(/\+/g, " "), "="),
            _l2 = _slicedToArray(_l, 2),
            _e = _l2[0],
            _i = _l2[1];

        _i = void 0 === _i ? null : h(_i, t), n(h(_e, t), _i, r);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return Object.keys(r).sort().reduce(function (e, t) {
      var n = r[t];
      return Boolean(n) && "object" == typeof n && !Array.isArray(n) ? e[t] = function e(t) {
        return Array.isArray(t) ? t.sort() : "object" == typeof t ? e(Object.keys(t)).sort(function (e, t) {
          return Number(e) - Number(t);
        }).map(function (e) {
          return t[e];
        }) : t;
      }(n) : e[t] = n, e;
    }, Object.create(null));
  },
      p = function p(e, t) {
    if (!e) return "";

    var n = function (e) {
      switch (e.arrayFormat) {
        case "index":
          return function (t) {
            return function (n, r) {
              var o = n.length;
              return void 0 === r ? n : null === r ? _toConsumableArray(n).concat([[f(t, e), "[", o, "]"].join("")]) : _toConsumableArray(n).concat([[f(t, e), "[", f(o, e), "]=", f(r, e)].join("")]);
            };
          };

        case "bracket":
          return function (t) {
            return function (n, r) {
              return void 0 === r ? n : null === r ? _toConsumableArray(n).concat([[f(t, e), "[]"].join("")]) : _toConsumableArray(n).concat([[f(t, e), "[]=", f(r, e)].join("")]);
            };
          };

        case "comma":
          return function (t) {
            return function (n, r, o) {
              return r ? 0 === o ? [[f(t, e), "=", f(r, e)].join("")] : [[n, f(r, e)].join(",")] : n;
            };
          };

        default:
          return function (t) {
            return function (n, r) {
              return void 0 === r ? n : null === r ? _toConsumableArray(n).concat([f(t, e)]) : _toConsumableArray(n).concat([[f(t, e), "=", f(r, e)].join("")]);
            };
          };
      }
    }(t = Object.assign({
      encode: !0,
      strict: !0,
      arrayFormat: "none"
    }, t)),
        r = Object.keys(e);

    return !1 !== t.sort && r.sort(t.sort), r.map(function (r) {
      var o = e[r];
      return void 0 === o ? "" : null === o ? f(r, t) : Array.isArray(o) ? o.reduce(n(r), []).join("&") : f(r, t) + "=" + f(o, t);
    }).filter(function (e) {
      return e.length > 0;
    }).join("&");
  },
      y = function () {
    function e(e) {
      this.all = e || {};
    }

    return e.prototype.on = function (e, t) {
      (this.all[e] || (this.all[e] = [])).push(t);
    }, e.prototype.off = function (e, t) {
      this.all[e] && (this.all[e] = this.all[e].filter(function (e) {
        return e !== t;
      }));
    }, e.prototype.emit = function (e, t) {
      (this.all[e] || []).forEach(function (e) {
        e(t);
      });
    }, e;
  }(),
      k = function () {
    function e(e) {
      var t = void 0 === e ? {} : e,
          n = t.storage,
          r = t.storageKey;
      this.storage = n || window.localStorage, this.key = r || "ace-sdk-tokens";
    }

    return e.isWritable = function (e) {
      return n(this, void 0, Promise, function () {
        var t, n;
        return r(this, function (r) {
          switch (r.label) {
            case 0:
              t = "ace-sdk-test", n = "ace-sdk-test-value", r.label = 1;

            case 1:
              return r.trys.push([1, 4,, 5]), [4, e.setItem(t, n)];

            case 2:
              return r.sent(), [4, e.removeItem(t)];

            case 3:
              return r.sent(), [2, !0];

            case 4:
              return r.sent(), [2, !1];

            case 5:
              return [2];
          }
        });
      });
    }, e.prototype.read = function (e) {
      return n(this, void 0, Promise, function () {
        return r(this, function (t) {
          return [2, this.storage.getItem(e || this.key)];
        });
      });
    }, e.prototype.write = function (t, o) {
      return n(this, void 0, Promise, function () {
        return r(this, function (n) {
          return e.isWritable(this.storage) ? t ? [2, this.storage.setItem(o || this.key, t)] : [2] : [2, Promise.reject("Storage is not writable")];
        });
      });
    }, e.prototype.clear = function (e) {
      return n(this, void 0, Promise, function () {
        return r(this, function (t) {
          return [2, this.storage.removeItem(e || this.key)];
        });
      });
    }, e;
  }();

  (d = e.Token || (e.Token = {})).getPayload = function (e) {
    if (e && 3 === e.split(".").length) try {
      var t = e.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
      return JSON.parse(decodeURIComponent(encodeURIComponent(window.atob(t))));
    } catch (e) {
      return;
    }
  }, d.getExpirationDate = function (e) {
    var t = d.getPayload(e),
        n = new Date(0);
    return n.setUTCSeconds(t ? t.exp : 0), n;
  }, d.isExpired = function (e) {
    return d.getExpirationDate(e).valueOf() <= new Date().valueOf();
  };

  var v = new (function () {
    function e() {
      this.verbose = !1;
    }

    return e.prototype.setOptions = function (e) {
      var t = e.verbose;
      this.verbose = t;
    }, e.prototype.log = function () {
      for (var e, t = [], n = 0; n < arguments.length; n++) {
        t[n] = arguments[n];
      }

      window.console && this.verbose && (e = window.console).log.apply(e, t);
    }, e;
  }())(),
      m = function (o) {
    function i(e) {
      var t = e.clientId,
          n = e.defaultRedirectUri,
          r = e.signInRedirectUri,
          s = e.signUpRedirectUri,
          c = e.signOutRedirectUri,
          a = e.aceEndpoint,
          u = e.ownAceEndpoint,
          l = e.locale,
          f = void 0 === l ? "en-US" : l,
          h = e.onTokens,
          d = e.autorefresh,
          g = void 0 !== d && d,
          p = function (e, t) {
        var n = {};

        for (var r in e) {
          Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
        }

        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
          var o = 0;

          for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) {
            t.indexOf(r[o]) < 0 && (n[r[o]] = e[r[o]]);
          }
        }

        return n;
      }(e, ["clientId", "defaultRedirectUri", "signInRedirectUri", "signUpRedirectUri", "signOutRedirectUri", "aceEndpoint", "ownAceEndpoint", "locale", "onTokens", "autorefresh"]),
          y = o.call(this) || this;

      return y.storage = new k(p), v.setOptions({
        verbose: Boolean(p.debug)
      }), t || i.throwCustomError("clientId"), a || i.throwCustomError("aceEndpoint"), y.aceEndpoint = a, y.clientId = t, y.defaultRedirectUri = n, y.signInRedirectUri = r, y.signUpRedirectUri = s, y.signOutRedirectUri = c, y.ownAceEndpoint = u, y.locale = f, y.initialTokensFetchDone = !1, y.autorefresh = g, h && y.on("tokens", h), v.log("constructor initialized."), y;
    }

    return function (e, n) {
      function r() {
        this.constructor = e;
      }

      _t(e, n), e.prototype = null === n ? Object.create(n) : (r.prototype = n.prototype, new r());
    }(i, o), i.throwCustomError = function (e) {
      throw new Error("Invalid param " + e + ".");
    }, i.prototype.getTokens = function (t) {
      return n(this, void 0, Promise, function () {
        var o,
            i,
            s,
            c = this;
        return r(this, function (a) {
          switch (a.label) {
            case 0:
              return v.log("getTokens()", t), o = t && t.force || !1, (!this.initialTokensFetchDone || o) && this.ownAceEndpoint ? (v.log("First time call and ownAceEndpoint is defined. Try fetch"), [2, this.fetchTokens().catch(function (e) {
                return n(c, void 0, void 0, function () {
                  return r(this, function (t) {
                    switch (t.label) {
                      case 0:
                        return w(e.status) ? [4, this.storage.clear()] : [3, 2];

                      case 1:
                        t.sent(), t.label = 2;

                      case 2:
                        return [2, Promise.reject(e)];
                    }
                  });
                });
              }).then(function (e) {
                return n(c, void 0, void 0, function () {
                  return r(this, function (t) {
                    switch (t.label) {
                      case 0:
                        return v.log("fetch result:", e), [4, this.maybeWriteTokens(e)];

                      case 1:
                        return t.sent(), this.scheduleRefreshTokens(e), [2, e];
                    }
                  });
                });
              })]) : !(i = this.parseTokensFromUrl()) || e.Token.isExpired(i.access_token) ? [3, 3] : [4, this.scheduleRefreshTokens(i)];

            case 1:
              return a.sent(), [4, this.maybeWriteTokens(i)];

            case 2:
              return a.sent(), [2, i];

            case 3:
              return [4, this.readTokensFromStorage()];

            case 4:
              return (s = a.sent()) ? e.Token.isExpired(s.access_token) ? (v.log("Access token expired"), [4, this.storage.clear()]) : [3, 6] : [3, 8];

            case 5:
              return a.sent(), [3, 8];

            case 6:
              return [4, this.scheduleRefreshTokens(s)];

            case 7:
              return a.sent(), [2, s];

            case 8:
              return [2, this.fetchTokens().catch(function (e) {
                return n(c, void 0, void 0, function () {
                  return r(this, function (t) {
                    switch (t.label) {
                      case 0:
                        return w(e.status) ? [4, this.storage.clear()] : [3, 2];

                      case 1:
                        t.sent(), t.label = 2;

                      case 2:
                        return [2, Promise.reject(e)];
                    }
                  });
                });
              }).then(function (e) {
                return n(c, void 0, void 0, function () {
                  return r(this, function (t) {
                    switch (t.label) {
                      case 0:
                        return v.log("fetch returned", e), [4, this.maybeWriteTokens(e)];

                      case 1:
                        return t.sent(), this.scheduleRefreshTokens(e), [2, e];
                    }
                  });
                });
              })];
          }
        });
      });
    }, i.prototype.refreshTokens = function () {
      return n(this, void 0, Promise, function () {
        var e = this;
        return r(this, function (t) {
          return v.log("refreshTokens()"), this.ownAceEndpoint ? [2, fetch(this.ownAceEndpoint + "/refresh-tokens", {
            credentials: "include"
          }).then(function (e) {
            return v.log("/refresh-tokens response", e), 200 === e.status ? e.json().then(function (e) {
              return v.log("tokens parsed"), e;
            }).catch(function () {
              v.log("tokens invalid json"), Promise.reject("Invalid json received");
            }) : Promise.reject(e);
          }).catch(function (t) {
            return n(e, void 0, void 0, function () {
              return r(this, function (e) {
                switch (e.label) {
                  case 0:
                    return w(t.status) ? [4, this.storage.clear()] : [3, 2];

                  case 1:
                    e.sent(), e.label = 2;

                  case 2:
                    return this.emit("tokens", null), [2, Promise.reject(t)];
                }
              });
            });
          }).then(function (t) {
            return n(e, void 0, void 0, function () {
              return r(this, function (e) {
                switch (e.label) {
                  case 0:
                    return v.log("fetch refresh tokens:", t), [4, this.maybeWriteTokens(t)];

                  case 1:
                    return e.sent(), this.scheduleRefreshTokens(t), [2, t];
                }
              });
            });
          })] : [2, Promise.reject("No ownAceEndpoint")];
        });
      });
    }, i.prototype.signIn = function () {
      var e = this;
      return v.log("signIn()"), this.getTokens().catch(function (t) {
        return n(e, void 0, void 0, function () {
          var e = this;
          return r(this, function (n) {
            return this.ownAceEndpoint && w(t.status) || !this.ownAceEndpoint ? (v.log("tokens not found. try to login"), [2, this.setOriginUrl().then(function () {
              return e.redirectToSignIn();
            }).then(function () {
              return v.log("Not redirected. Rejecting"), Promise.reject(t);
            })]) : (v.log("tokens not found"), [2, Promise.reject(t)]);
          });
        });
      });
    }, i.prototype.signUp = function (e) {
      var t = this;
      return v.log("signUp()", e), this.setOriginUrl().then(function () {
        v.log("redirecting");
        var n = t.getSignUpUrl(e);
        window.location.assign(n);
      });
    }, i.prototype.signOut = function (e) {
      var t = this;
      v.log("signOut()", e);
      var n = this.getSignOutRedirectUri();
      return (this.ownAceEndpoint ? fetch(this.ownAceEndpoint + "/logout?redirect_uri=" + encodeURIComponent(n), {
        credentials: "include"
      }).then(function () {
        v.log("fetching logout");
      }) : Promise.resolve()).then(function () {
        t.storage.clear(), v.log("cleared storage");
      }).then(function () {
        e && e.reload, window.location.assign(t.aceEndpoint + "/signout?redirect_uri=" + encodeURIComponent(n));
      });
    }, i.prototype.setLocale = function (e) {
      return v.log("setLocale()", e), this.locale = e, this.locale;
    }, i.prototype.getOriginUrl = function () {
      return v.log("getOriginUrl()"), this.storage.read("ace-sdk-origin");
    }, i.prototype.getSignInUrl = function () {
      v.log("getSignInUrl()");
      var e = this.signInRedirectUri || this.defaultRedirectUri || "";
      e || i.throwCustomError("signInRedirectUri, defaultRedirectUri");
      var t = {
        client_id: this.clientId,
        redirect_uri: e,
        locale: String(this.locale)
      };
      return this.aceEndpoint + "/signin?" + p(t);
    }, i.prototype.getSignUpUrl = function (e) {
      v.log("getSignUpUrl()", e);
      var t = e && e.referrer ? e.referrer : e && !e.referrer ? "VIP" : "",
          n = this.signUpRedirectUri || this.defaultRedirectUri || "";
      n || i.throwCustomError("signUpRedirectUri, defaultRedirectUri");
      var r = {
        referrer: t,
        client_id: this.clientId,
        redirect_uri: n,
        locale: String(this.locale)
      };
      return this.aceEndpoint + "/signup?" + p(r);
    }, i.prototype.clearStorage = function () {
      return v.log("clearStorage"), this.storage.clear();
    }, i.prototype.getSignOutRedirectUri = function () {
      v.log("getSignOutRedirectUri()");
      var e = this.signOutRedirectUri || this.defaultRedirectUri || "";
      return e || i.throwCustomError("signOutRedirectUri, defaultRedirectUri"), e;
    }, i.prototype.setSignOutRedirectUri = function (e) {
      v.log("setSignOutRedirectUri()", e), this.signOutRedirectUri = e;
    }, i.prototype.setOriginUrl = function () {
      return v.log("setOriginUrl()"), this.storage.write(window.location.href, "ace-sdk-origin");
    }, i.prototype.redirectToSignIn = function () {
      v.log("redirectToSignIn()");
      var e = this.getSignInUrl();
      window.location.assign(e);
    }, i.prototype.readTokensFromStorage = function () {
      var e = this;
      return v.log("readTokensFromStorage()"), this.storage.read().then(function (t) {
        if (t) {
          v.log("tokens read successfully");

          try {
            var n = JSON.parse(t);
            if (v.log("tokens parsed successfully"), n && n.access_token) return n;
            v.log("tokens expired");
          } catch (t) {
            v.log("error parse JSON tokens"), e.storage.clear(), v.log("cleared storage");
          }
        } else v.log("no tokens in storage");
      });
    }, i.prototype.maybeWriteTokens = function (e) {
      return n(this, void 0, Promise, function () {
        var t, n, o, i;
        return r(this, function (r) {
          switch (r.label) {
            case 0:
              return v.log("maybeWriteTokens()", e), [4, this.readTokensFromStorage()];

            case 1:
              return (t = r.sent()) ? (n = t.access_token === e.access_token, o = t.id_token === e.id_token, i = t.refresh_token === e.refresh_token, n && o && i ? [3, 3] : (v.log("Tokens are not equal. Saving new tokens"), [4, this.storage.write(JSON.stringify(e))])) : [3, 4];

            case 2:
              r.sent(), this.emit("tokens", e), r.label = 3;

            case 3:
              return [3, 6];

            case 4:
              return v.log("Save tokens to storage"), [4, this.storage.write(JSON.stringify(e))];

            case 5:
              r.sent(), this.emit("tokens", e), r.label = 6;

            case 6:
              return [2];
          }
        });
      });
    }, i.prototype.fetchTokens = function () {
      return v.log("fetchTokens"), this.initialTokensFetchDone = !0, fetch(this.ownAceEndpoint + "/get-tokens", {
        credentials: "include"
      }).then(function (e) {
        return v.log("tokens fetch response", e), 200 === e.status ? e.json().then(function (e) {
          return v.log("tokens parsed"), e;
        }).catch(function () {
          v.log("tokens invalid json"), Promise.reject("Invalid json received");
        }) : Promise.reject(e);
      });
    }, i.prototype.parseTokensFromUrl = function () {
      v.log("parseTokensFromUrl()");
      var e = g(window.location.search.slice(1));
      return e.access_token && e.id_token ? (v.log("tokens from url parsed"), {
        access_token: String(e.access_token),
        id_token: String(e.id_token),
        refresh_token: String(e.refresh_token)
      }) : (v.log("Parse tokens from url failed. Looks like there is no access_token or id_token"), null);
    }, i.prototype.scheduleRefreshTokens = function (t) {
      return n(this, void 0, Promise, function () {
        var o,
            i,
            s,
            c = this;
        return r(this, function (a) {
          return this.ownAceEndpoint && this.autorefresh ? (this.refreshTokenTimout && clearTimeout(this.refreshTokenTimout), o = e.Token.getExpirationDate(t.access_token).getTime(), i = Date.now(), (s = o - 12e4) > i ? (this.refreshTokenTimout = setTimeout(function () {
            return n(c, void 0, void 0, function () {
              return r(this, function (e) {
                switch (e.label) {
                  case 0:
                    return [4, this.storage.clear()];

                  case 1:
                    return e.sent(), [2, this.refreshTokens().catch(function () {})];
                }
              });
            });
          }, s - i), [2]) : [2, this.refreshTokens()]) : [2];
        });
      });
    }, i;
  }(y);

  function w(e) {
    return v.log("isUnauthorized(). response status", e), 401 === e || 403 === e;
  }

  e.CreateClient = m, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});